import type { ComponentProps } from 'react';

export const CrossIcon = (props: ComponentProps<'svg'>) => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M58 22L40 40M22 58L40 40M40 40L22 22M40 40C41.1676 40.7784 52.4865 52.3243 58 58" stroke="currentColor"
          strokeWidth="6" strokeLinecap="round" strokeLinejoin="bevel" />
  </svg>
);